import CoreInput from "componets/core-input/core-input";

export default CoreInput